import React from "react";
import "./index.css";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
//import "@fortawesome/fontawesome-free/css/all.min.css";

// i18next yapılandırma dosyanı import et (önce oluşturulmalı)
import "./i18n.js"; // bu dosyayı oluşturacağız

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Header />
      <App />
      <Footer />
    </BrowserRouter>
  </React.StrictMode>
);
